// extracted by mini-css-extract-plugin
module.exports = {"main":"TourenApp_main__1KWRo","text":"TourenApp_text__bfmqU","stores":"TourenApp_stores__2kA8a"};